<template>
  <div>
    <vs-popup :title="$t('Options')" :active.sync="showModal">
      <div class="vx-row  mb-6">
        <div class="vx-col lg:w-4/5 w-full mb-2">
          <vs-input class="inputx mb-4 mt-1" v-model="optionName" name="option" :label="$t('Title')" v-validate="'required'" />
          <span class="text-danger text-sm" v-show="errors.has('option')">{{ errors.first('option') }}</span>
        </div>
        <div class="vx-col lg:w-1/5 w-full mt-6">
          <vs-button size="small" radius color="success" type="gradient" icon-pack="feather" icon="icon-plus" @click.prevent="addOption()" class="mb-2 mt-2 lfloat"></vs-button>
        </div>
      </div>

      <vs-table :data="model">
        <template slot="thead">
          <vs-th>#</vs-th>
          <vs-th>{{ $t('Title') }}</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr v-for="(item, index) in data" :key="item.key">
            <vs-td class="index-td">
              {{ index + 1 }}
            </vs-td>
            <vs-td>
              {{ item.value }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>
  </div>
</template>
<script>
import { Validator } from 'vee-validate';

const dict = {
  custom: {
    option: {
      required: 'لطفا گزینه را وارد نمایید.',
    },
  },
};
Validator.localize('fa', dict);
export default {
  props: {
    show: { default: false },
    model: {
      default: {},
    },
    keywords: {},
  },
  data() {
    return {
      optionName: '',
    };
  },
  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function() {
        this.$emit('finish');
      },
    },
  },
  methods: {
    addOption() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.model.unshift({ value: this.optionName, key: null });
          setTimeout(() => {
            this.optionName = null;
            this.$validator.reset();
          }, 0);
        } else {
          // form have errors
        }
      });
    },
    deleteOption() {},
  },
  watch: {
    show() {
      if (!this.show) {
        this.optionName = null;
        this.$validator.reset();
      }
    },
  },
};
</script>
